module.exports = __webpack_public_path__ + "img/2dac647.jpg";